import { Close } from '@mui/icons-material';
import PropTypes from 'prop-types';
import React from 'react';
import HrbTranslate from '../../../../components/language/HrbTranslate';
import Button from '../../../../components/library/buttons/Button';
import DefaultModal from '../../../../components/library/modal/DefaultModal';
import WorkflowStatusIcon from '../../../../components/library/workflow-tasks/WorkflowStatusIcon';
import { TaskStatus } from '../../services/TaskStatus';
import './AssignAgentPane.scss';

const AssignErrorModal = (props) => {

    const { isOpen, onClose } = props

    return (
        <DefaultModal isOpen={isOpen}>
            <div className='assign-error-modal'>
                <div className='columns level header'>
                    <div className='column is-1'>
                        <WorkflowStatusIcon status={TaskStatus.IN_PROGRESS} />
                    </div>
                    <div className='column is-10'>
                        <h4><HrbTranslate text='ManageTicket.AssignmentError.Title' /></h4>
                    </div>
                    <div className='column is-1 close-btn' onClick={onClose}>
                        <Close />
                    </div>
                </div>
                <div className='columns content'>
                    <div className='column is-1' />
                    <div className='column is-10'>
                        <p className='p2 error-text mb-2'><HrbTranslate text='ManageTicket.AssignmentError.Warning' /></p>
                        <p className='p2 mb-2'><HrbTranslate text='ManageTicket.AssignmentError.InvalidAgent' /></p>
                    </div>
                    <div className='column is-1' />
                </div>
                <div className='columns content'>
                    <div className='column is-1' />
                    <div className='column is-10'>
                        <div className='button-holder'>
                            <Button
                                elementId='assign-error-close-btn'
                                labelKey='App.Close'
                                buttonStyles='secondary'
                                onClick={() => onClose()} />
                        </div>
                    </div>
                    <div className='column is-1' />
                </div>
            </div>
        </DefaultModal>
    );
}

AssignErrorModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func
}

export default AssignErrorModal